"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ActionType;
(function (ActionType) {
    ActionType[ActionType["CallActivity"] = 0] = "CallActivity";
    ActionType[ActionType["CallActivityWithRetry"] = 1] = "CallActivityWithRetry";
    ActionType[ActionType["CallSubOrchestrator"] = 2] = "CallSubOrchestrator";
    ActionType[ActionType["CallSubOrchestratorWithRetry"] = 3] = "CallSubOrchestratorWithRetry";
    ActionType[ActionType["ContinueAsNew"] = 4] = "ContinueAsNew";
    ActionType[ActionType["CreateTimer"] = 5] = "CreateTimer";
    ActionType[ActionType["WaitForExternalEvent"] = 6] = "WaitForExternalEvent";
    ActionType[ActionType["CallEntity"] = 7] = "CallEntity";
    ActionType[ActionType["CallHttp"] = 8] = "CallHttp";
    ActionType[ActionType["WhenAny"] = 11] = "WhenAny";
    ActionType[ActionType["WhenAll"] = 12] = "WhenAll";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
//# sourceMappingURL=actiontype.js.map